import { ExportSheet } from '../core';
import { DataPreparer } from '../factory';

export class ListagemFluxosAdminEtapasExportPreparer implements DataPreparer {
  async prepareForExport(selectedItems: any[]): Promise<ExportSheet[]> {
    const mainSheetData = selectedItems.map((item) => ({
      id: item.id,
      ordem: item.ordem,
      etapa: item.etapa,
      areaResponsavel: item.areaResponsavel,
      estimativaDias: item.estimativaDias,
      descricao: item.descricao,
      observacao: item.observacao,
      modelo: item.modeloNome,
      usuarioRegistro: item.usuarioRegistro?.nomeCompleto || 'N/A',
      dataRegistro: item.dataRegistro,
      usuarioAtualizacao: item.usuarioAtualizacao?.nomeCompleto || 'N/A',
      dataUltimaAtualizacao: item.dataUltimaAtualizacao,
      nEdicoes: item.nEdicoes || 0,
    }));

    const mainSheet: ExportSheet = {
      name: 'Fluxo Adm Etapas',
      columns: {
        id: 'ID',
        ordem: 'Ordem',
        etapa: 'Etapa',
        areaResponsavel: 'Área Responsável',
        estimativaDias: 'Estimativa (dias)',
        descricao: 'Descrição',
        observacao: 'Observação',
        modelo: 'Modelo',
        usuarioRegistro: 'Responsável pelo Registro',
        dataRegistro: 'Data de Registro',
        usuarioAtualizacao: 'Responsável Ult. Atualização',
        dataUltimaAtualizacao: 'Última Atualização',
        nEdicoes: 'Edições',
      },
      data: mainSheetData,
    };

    return [mainSheet];
  }
}
